import { render, staticRenderFns } from "./AthleteForm.vue?vue&type=template&id=3a0658ec&"
import script from "./AthleteForm.vue?vue&type=script&lang=js&"
export * from "./AthleteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports